import { initialState } from "./selectors";
import dayjs from "dayjs";
import {
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILEHASH_REQUEST,
  GET_PROFILEHASH_SUCCESS,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  GET_PROFILE_INFO_SUCCESS,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_UNSEEN_NOTIFICATIONS_REQUEST,
  GET_UNSEEN_NOTIFICATIONS_SUCCESS,
  SET_UNREAD_STATUS_REQUEST,
  SET_UNREAD_STATUS_SUCCESS,
  SET_SEEN_STATUS_BULK_REQUEST,
  SET_SEEN_STATUS_BULK_SUCCESS,
  GET_TASKS_REQUEST,
  GET_TASKS_SUCCESS,
  SHOW_CHALLENGE_MODAL,
  HIDE_CHALLENGE_MODAL,
  SET_CHALLENGE_MODAL_DATA,
  ADD_WHEEL_POINTS,
  ADD_WHEEL_POINTS_SUCCESS,
  HIDE_WHEEL_POINTS_ANIMATION,
  SHOW_USER_PROFILE_MODAL,
  HIDE_USER_PROFILE_MODAL,
} from "./actions";

export default function user(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    // Auth check
    case GET_PROFILE_SUCCESS:
      if (payload && payload._id) {
        localStorage.setItem("profileId", payload._id);
      }
      return {
        ...state,
        profile: payload,
      };
    case GET_PROFILE_REQUEST:
      return {
        ...state,
      };
    case GET_PROFILEHASH_SUCCESS:
      return {
        ...state,
        profile: payload.profile,
      };
    case GET_PROFILEHASH_REQUEST:
      return {
        ...state,
        profile: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        profile: payload.profile,
      };
    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
      };
    case GET_PROFILE_INFO_SUCCESS:
      return {
        ...state,
        profileInfo: {
          user: payload.user,
          touchPoints: payload.touchPoints,
          ranking: payload.user.ranking,
          rankingStage: payload.user.rankingStage,
          rankingPosition: payload.user.rankingPosition,
        },
      };
    case GET_NOTIFICATIONS_REQUEST:
      return {
        ...state,
      };
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: payload,
      };
    case GET_UNSEEN_NOTIFICATIONS_REQUEST:
      return {
        ...state,
      };
    case GET_UNSEEN_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        unseenNotificationsCount: payload,
      };
    case SET_UNREAD_STATUS_REQUEST:
      return {
        ...state,
      };
    case SET_UNREAD_STATUS_SUCCESS:
      const newNotifications = state.notifications.map(n => {
        if (payload.notificationId === n._id) {
          n.isReviewed = payload.isReviewed;
        }
        return n;
      });
      return {
        ...state,
        notifications: newNotifications,
      };
    case SET_SEEN_STATUS_BULK_REQUEST:
      return {
        ...state,
      };
    case SET_SEEN_STATUS_BULK_SUCCESS:
      return {
        ...state,
        notifications: state.notifications,
        unseenNotificationsCount: null,
      };
    case GET_TASKS_REQUEST:
      return {
        ...state,
      };
    case GET_TASKS_SUCCESS:
      const mappedTasks = payload.tasks.map(task => {
        const completionInCalculation = task.isWorkspaceTask ? task.workspaceCompletionLevel : task.completionLevel;
        task.isFulfilled = (!!task.quantity && completionInCalculation >= task.quantity) || task.booleanCompletion;
        if (task.teamTaskGroup) {
          if (task.teamTaskType === "all") {
            task.isFulfilled = task.teamsCompletion >= task.teamsCompletionNeeded;
          } else {
            task.isFulfilled = task.teamsCompletion >= task.quantity;
          }
        }
        return task;
      });
      const fulfilled = mappedTasks.filter(t => t.isFulfilled);
      const current = mappedTasks.filter(
        t =>
          !t.isFulfilled && (dayjs(t.end).isAfter(dayjs(), "date") || dayjs().isSame(dayjs(t.end), "date") || !t.end),
      );
      const ended = mappedTasks.filter(t => !t.isFulfilled && dayjs(t.end).isBefore(dayjs(), "date"));
      const featuredTask = mappedTasks.find(t => t.isFeaturedChallenge) || null;
      return {
        ...state,
        tasks: {
          user: {
            current: current.filter(t => !t.isWorkspaceTask),
            ended: ended.filter(t => !t.isWorkspaceTask),
            fulfilled: fulfilled.filter(t => !t.isWorkspaceTask),
          },
          workspace: {
            current: current.filter(t => t.isWorkspaceTask),
            ended: ended.filter(t => t.isWorkspaceTask),
            fulfilled: fulfilled.filter(t => t.isWorkspaceTask),
          },
          featuredTask: featuredTask,
        },
      };
    case SHOW_CHALLENGE_MODAL:
      return {
        ...state,
        challengeModalVisible: true,
      };
    case HIDE_CHALLENGE_MODAL:
      return {
        ...state,
        challengeModalVisible: false,
      };
    case SET_CHALLENGE_MODAL_DATA:
      const uncheckedTasks = JSON.parse(localStorage.getItem("uncheckedTasks"));
      const uncheckedUserTasks =
        uncheckedTasks && uncheckedTasks[state.profile._id] ? new Set(uncheckedTasks[state.profile._id]) : new Set();
      const challengeModalData = payload.filter(data => !uncheckedUserTasks.has(data._id));
      return {
        ...state,
        challengeModalVisible: challengeModalData.length > 0,
        challengeModalData: challengeModalData,
      };
    case ADD_WHEEL_POINTS:
      return {
        ...state,
      };
    case ADD_WHEEL_POINTS_SUCCESS:
      return {
        ...state,
        tasks: {
          ...state.tasks,
          user: {
            ...state.tasks.user,
            current: state.tasks.user.current.map(t => {
              if (t._id !== payload?.wheelPoints?.taskId) return t;
              return { ...t, completionLevel: payload?.wheelPoints?.spinsCount, wheelPoints: payload?.wheelPoints };
            }),
          },
          featuredTask:
            !state?.tasks?.featuredTask || state?.tasks?.featuredTask?._id !== payload?.wheelPoints?.taskId
              ? state.tasks.featuredTask
              : {
                  ...state.tasks.featuredTask,
                  completionLevel: payload?.wheelPoints?.spinsCount,
                  wheelPoints: payload?.wheelPoints,
                },
        },
        wheelPoints: payload?.earnedPoints,
        wheelPointsAnimationVisible: !!payload?.earnedPoints,
      };
    case HIDE_WHEEL_POINTS_ANIMATION:
      return {
        ...state,
        wheelPoints: null,
        wheelPointsAnimationVisible: false,
      };
    case SHOW_USER_PROFILE_MODAL:
      return {
        ...state,
        userProfileVisible: true,
        selectedUserId: payload.userId,
      };
    case HIDE_USER_PROFILE_MODAL:
      return {
        ...state,
        userProfileVisible: false,
        selectedUserId: null,
      };
    default:
      return state;
  }
}
